import React from "react";
import { Link } from "react-router-dom";

const Post = ({
  title,
  subTitle,
  description,
  image,
  position = "left",
  btnText,
  btnLink,
}) => {
  const isImageLeft = position === "left";

  return (
    <div
      className="flex lg:flex-col flex-row items-center gap-6 mb-20 backdrop-blur-md rounded-2xl bg-mainBg/50"
      style={{
        boxShadow: "#3a4b4920 0px 0px 20px 0px",
      }}
    >
      {/* Image Section */}
      <div
        className={`w-full  bg-cover bg-center bg-no-repeat rounded-2xl ${
          isImageLeft ? "order-1 " : "order-2 "
        } flex justify-center`}
        style={{
          backgroundImage: `url(${image})`,
        }}
      >
        <div
          className={`w-full h-full p-8 bg-slate-900/40 backdrop-blur-md ${
            isImageLeft
              ? " rounded-l-2xl md:rounded-l-none md:rounded-t-2xl "
              : " rounded-r-2xl md:rounded-r-none md:rounded-b-2xl"
          }`}
        >
          <img
            src={image}
            alt={title}
            className="rounded-xl shadow-lg object-cover w-full max-h-[380px]"
          />
        </div>
      </div>
      {/* Text Section */}
      <div
        className={`w-full  p-8 ${
          isImageLeft ? "order-2" : "order-1"
        } text-center lg:text-left`}
      >
        <h2 className="hero-h2 text-center">{title}</h2>
        <h4 className="text-xl sm:text-sm mb-5 text-mainColor text-center">
          {subTitle}
        </h4>
        <p className="text-lg text-slate-500 text-right mb-5">{description}</p>
        <div className="my-5 text-center ">
          <Link to={`${btnLink}`}>
            <button className="main-btn2"> {btnText} </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Post;
